export default "__VITE_ASSET__0e4c9467__"